import React from "react";
import Icon from "../Icon";
import classes from "./styles.module.css";

/**
 * FilterPanel — выдвижная панель фильтров справа.
 *
 * Использование:
 *   <FilterPanel isOpen={bool} onClose={fn} title="Фильтры"
 *                content={<div>...основной контент страницы...</div>}>
 *     {children — содержимое фильтров}
 *   </FilterPanel>
 *
 * Когда панель открыта, content сжимается (margin-right), панель не перекрывает контент.
 */
function FilterPanel({ children, isOpen, onClose, title, content }) {
    // display:none когда закрыта — сохраняем state дочерних компонентов
    var panelStyle = isOpen ? {} : { display: "none" };

    var contentClass = classes.ContentShift + (isOpen ? " " + classes.ContentShiftOpen : "");

    return (
        <React.Fragment>
            <div className={contentClass}>
                {content}
            </div>
            <div
                className={classes.Panel + (isOpen ? " " + classes.PanelOpen : "")}
                style={panelStyle}
            >
                <div className={classes.Header}>
                    <h3 className={classes.Title}>{title}</h3>
                    <button className={classes.CloseBtn} onClick={onClose} type="button">
                        <Icon icon="close" size="15px" />
                    </button>
                </div>
                <div className={classes.Body}>
                    {children}
                </div>
            </div>
        </React.Fragment>
    );
}

export default FilterPanel;



// WEBPACK FOOTER //
// ./src/Components/Utils/FilterPanel/index.js